import { GroupMeetingType } from '@common/enums';
import { EpisodeCategoryOutclinicDashboard } from '@frontend/components/pages/outclinicDashboard/EpisodeCategoryOutclinicDashboard';
import { OutpatientClinicTaskList } from '@frontend/components/pages/outpatientClinic/OutpatientClinicTaskList';
import { AdminHomepage } from './components/AdminHomepage';
import { CatchExactRedirect } from './components/elements/CatchExactRedirect';
import { PatientQuestionnaireExport } from './components/elements/PatientQuestionnaireExport';
import { AccountRequestReviewByKsyosPage } from './components/pages/accountRequests/reviewByKsyos/AccountRequestReviewByKsyosPage';
import { AccountRequestReviewByOrganizationPage } from './components/pages/accountRequests/reviewByOrganization/AccountRequestReviewByOrganizationPage';
import { CompensationPayoutAddEdit } from './components/pages/compensationPayouts/CompensationPayoutAddEdit';
import { ServiceActivityCompensationPayoutAddEdit } from './components/pages/compensationPayouts/ServiceActivityCompensationPayoutAddEdit';
import { ContactsAndTasksPage } from './components/pages/contactsAndTasks/ContactsAndTasksPage';
import { DataChecks } from './components/pages/dataChecks/DataChecks';
import { DeclarationActivityAddEdit } from './components/pages/declarationActivities/DeclarationActivityAddEdit';
import { DermaAppLoginsList } from './components/pages/dermaApp/DermaAppLoginsList';
import { DermaAppRegistrationsList } from './components/pages/dermaApp/DermaAppRegistrationsList';
import { DesktopProcessesList } from './components/pages/desktopProcesses/DesktopProcessesList';
import { DeviceAccessoriesAddEdit } from './components/pages/deviceAccessories/DeviceAccessoriesAddEdit';
import { DeviceAccessoryTypesAddEdit } from './components/pages/deviceAccessoryTypes/DeviceAccessoryTypesAddEdit';
import { DeviceAccessoryTypesList } from './components/pages/deviceAccessoryTypes/DeviceAccessoryTypesList';
import { DeviceDetails } from './components/pages/devices/DeviceDetails';
import {
    DevicesAndAccessories,
    DevicesAndAccessoriesTab,
} from './components/pages/devicesAndAccessories/DevicesAndAccessories';
import { DeviceTypesAddEdit } from './components/pages/deviceTypes/DeviceTypesAddEdit';
import { DeviceTypesList } from './components/pages/deviceTypes/DeviceTypesList';
import { EmbloomQuestionnairesList } from './components/pages/embloomQuestionnaires/EmbloomQuestionnairesList';
import { EmploymentsAddEdit } from './components/pages/employments/EmploymentsAddEdit';
import { EmploymentsSelectOneServiceProvider } from './components/pages/employments/EmploymentsSelectOneServiceProvider';
import { LoginSelectEmployment } from './components/pages/employments/LoginSelectEmployment';
import { SsoSelectEmployment } from './components/pages/employments/SsoSelectEmployment';
import { ExportForDato } from './components/pages/episodeCategory/bariatrics/exportForDato/ExportForDato';
import { PatientEpisodeCategory } from './components/pages/episodeCategory/PatientEpisodeCategory';
import { Episode } from './components/pages/episodes/Episode';
import { NotFoundError } from './components/pages/errors/NotFoundError';
import { FeatureFlags } from './components/pages/featureFlags/FeatureFlags';
import { FillDummyEctosenseReports } from './components/pages/fillDummyEctosenseReports/FillDummyEctosenseReports';
import { DeclarationsExport } from './components/pages/finance/DeclarationsExport';
import { EmploymentTaxesDetailsExport } from './components/pages/finance/EmploymentTaxesDetailsExport/EmploymentTaxesDetailsExport';
import { Financing } from './components/pages/finance/financing/Financing';
import { FundingLogs } from './components/pages/finance/FundingLogs';
import { InvoiceRecordsExport } from './components/pages/finance/InvoiceRecordsExport';
import { Payments } from './components/pages/finance/Payments/Payments';
import { PaymentsExport } from './components/pages/finance/PaymentsExport';
import { RequestFinancialExport } from './components/pages/finance/RequestFinancialExport/RequestFinancialExport';
import { FundingSettingsAddEdit } from './components/pages/fundingSettings/FundingSettingsAddEdit';
import { FundusNoShowsExportRequests } from './components/pages/fundusNoShows/FundusNoShowsExportRequests';
import { FundusNoShowsList } from './components/pages/fundusNoShows/FundusNoShowsList';
import { FundusScreeningManualImportPage } from './components/pages/fundusScreening/fundusScreeningManualImport/FundusScreeningManualImportPage';
import { GroupMeetingManagement } from './components/pages/groupMeeting/GroupMeetingManagement';
import { GroupsAddEdit } from './components/pages/groups/groupsAddEdit/GroupsAddEdit';
import { GroupsDetails } from './components/pages/groups/GroupsDetails';
import { GroupsList } from './components/pages/groups/GroupsList';
import { GroupView } from './components/pages/groups/GroupView';
import { HolterDashboard } from './components/pages/holters/HolterDashboard';
import { HomePage } from './components/pages/home/HomePage';
import { ImportBankAccountDetails } from './components/pages/imports/ImportBankAccountDetails';
import { ImportDhd } from './components/pages/imports/ImportDhd';
import { ImportNoShows } from './components/pages/imports/ImportNoShows';
import { ImportOtpDevices } from './components/pages/imports/ImportOtpDevices';
import { ImportRelationNumbers } from './components/pages/imports/ImportRelationNumbers';
import { InsurerAddEdit } from './components/pages/insurers/InsurerAddEdit';
import { InsurerDetails } from './components/pages/insurers/InsurerDetails';
import { InsurersList } from './components/pages/insurers/InsurersList';
import { InsurerServiceDeclarationActivityAddEdit } from './components/pages/insurerServiceDeclarationActivities/InsurerServiceDeclarationActivityAddEdit';
import { InsurerServiceAddEdit } from './components/pages/insurerServiceDeclarationRules/InsurerServiceDeclarationRuleAddEdit';
import { InsurerServiceRead } from './components/pages/insurerServiceDeclarationRules/InsurerServiceDeclarationRuleRead';
import { InsurerServiceDeclarationSettingAddEdit } from './components/pages/insurerServiceDeclarationSettings/InsurerServiceDeclarationSettingAddEdit';
import { InsurerTurnoverCeilingAddEdit } from './components/pages/insurerTurnoverCeilings/InsurerTurnoverCeilingAddEdit';
import { InsurerUzoviAddEdit } from './components/pages/insurerUzovis/InsurerUzoviAddEdit';
import { JobsList } from './components/pages/jobs/JobsList';
import { ManagerRolesAuthorizations } from './components/pages/managerAuthorizations/ManagerRolesAuthorizations';
import { NzaServiceDeclarationActivityAddEdit } from './components/pages/nzaServiceDeclarationActivities/NzaServiceDeclarationActivityAddEdit';
import { NzaServiceDeclarationSettingAddEdit } from './components/pages/nzaServiceDeclarationSettings/NzaServiceDeclarationSettingAddEdit';
import { OrderSupplies } from './components/pages/orderSupplies/OrderSupplies';
import { OrderSuppliesSuccess } from './components/pages/orderSupplies/OrderSuppliesSuccess';
import { OrganizationServiceEmailNotificationSettings } from './components/pages/organizations/emailNotificationSettings/OrganizationServiceEmailNotificationSettings';
import { OrganizationAdd } from './components/pages/organizations/organizationAdd/OrganizationAdd';
import { OrganizationAddCarePath } from './components/pages/organizations/organizationAddCarePath/OrganizationAddCarePath';
import { OrganizationAdminDetails } from './components/pages/organizations/OrganizationAdminDetails';
import { OrganizationCarePath } from './components/pages/organizations/OrganizationCarePath';
import { OrganizationCarePathsOverview } from './components/pages/organizations/OrganizationCarePathsOverview';
import { OrganizationDetails } from './components/pages/organizations/organizationDetails/OrganizationDetails';
import { OrganizationFunding } from './components/pages/organizations/OrganizationFunding';
import { OrganizationInactiveCarePaths } from './components/pages/organizations/OrganizationInactiveCarePaths';
import { OrganizationOverview } from './components/pages/organizations/OrganizationOverview';
import { OrganizationPatientCount } from './components/pages/organizations/OrganizationPatientCount';
import { OrganizationPayments } from './components/pages/organizations/OrganizationPayments';
import { OrganizationsList } from './components/pages/organizations/OrganizationsList';
import { OrganizationView } from './components/pages/organizations/OrganizationView';
import { OrganizationWaitingTimes } from './components/pages/organizations/OrganizationWaitingTimes';
import { PatientAccessList } from './components/pages/patientAccessLog/PatientAccessList';
import { PatientDetails } from './components/pages/patients/PatientDetails';
import { Patients } from './components/pages/patients/Patients';
import { PatientsAddEdit } from './components/pages/patients/PatientsAddEdit';
import { PatientSelectOrAdd } from './components/pages/patients/PatientSelectOrAdd';
import { NewPatientSearchBar } from './components/pages/patients/searchPatient/NewPatientSearchBar';
import { PatientSearchWithoutIdentifierSocialSecurity } from './components/pages/patients/searchPatient/PatientSearchWithoutIdentifierSocialSecurity';
import { PatientMergeSsoWrapper } from './components/pages/patients/ssoPatientFlow/PatientMergeSsoWrapper';
import { PatientNotFoundSso } from './components/pages/patients/ssoPatientFlow/PatientNotFoundSso';
import { PatientSsoInsufficientData } from './components/pages/patients/ssoPatientFlow/PatientSsoInsufficientData';
import { ActivityCompensationPayoutsList } from './components/pages/personalSettings/activityCompensationPayouts/ActivityCompensationPayoutsList';
import { PersonalSettingsAddCarePath } from './components/pages/personalSettings/addCarePath/PersonalSettingsAddCarePath';
import { PersonalSettingsAddRights } from './components/pages/personalSettings/addRights/PersonalSettingsAddRights';
import { PersonalSettingsCarePathsOverview } from './components/pages/personalSettings/carePathOverview/PersonalSettingsCarePathsOverview';
import { ServiceEmailNotificationSettings } from './components/pages/personalSettings/emailNotificationSettings/ServiceEmailNotificationSettings';
import { GgzPersonalSettingsContainer } from './components/pages/personalSettings/ggz/GgzPersonalSettingsContainer';
import { PersonalSettings } from './components/pages/personalSettings/PersonalSettings';
import { PersonalSettingsActivityCompensationPayoutsList } from './components/pages/personalSettings/PersonalSettingsActivityCompensationPayoutsList';
import { PersonalSettingsCarePath } from './components/pages/personalSettings/PersonalSettingsCarePath';
import { PersonalSettingsInactiveCarePaths } from './components/pages/personalSettings/PersonalSettingsInactiveCarePaths';
import { PersonalSettingsOverview } from './components/pages/personalSettings/PersonalSettingsOverview';
import { PersonalSettingsPreferenceListConsumerContainerOrganizationWrapper } from './components/pages/personalSettings/preferenceLists/PersonalSettingsPreferenceListConsumerContainerOrganizationWrapper';
import { PersonalSettingsPreferenceListConsumerContainerWrapper } from './components/pages/personalSettings/preferenceLists/PersonalSettingsPreferenceListConsumerContainerWrapper';
import { PersonalSettingsPreferenceListProviderContainer } from './components/pages/personalSettings/preferenceLists/PersonalSettingsPreferenceListProviderContainer';
import { AddKsyosEmployee } from './components/pages/practitioners/addKsyosEmployee/AddKsyosEmployee';
import { EmploymentAdd } from './components/pages/practitioners/EmploymentAdd';
import { PractitionerDetails } from './components/pages/practitioners/PractitionerDetails';
import { PractitionerPayments } from './components/pages/practitioners/PractitionerPayments';
import { PractitionerProfile } from './components/pages/practitioners/PractitionerProfile';
import { PractitionersList } from './components/pages/practitioners/PractitionersList';
import { AdminProcessDetails } from './components/pages/processes/AdminProcessDetails';
import { AdminProcesses } from './components/pages/processes/AdminProcesses';
import { NewAdminProcessDetails } from './components/pages/processes/NewAdminProcessDetails';
import { ProfileSettings } from './components/pages/profile/ProfileSettings';
import { SecuritySettings } from './components/pages/profile/SecuritySettings';
import { SetMfa } from './components/pages/profile/SetMfa';
import { SingleSignOnSettings } from './components/pages/profile/SingleSignOnSettings';
import { RequestsListContainer } from './components/pages/requests/RequestsListContainer';
import { ServiceConsumerAddEdit } from './components/pages/serviceConsumers/ServiceConsumerAddEdit';
import { ServiceGraderPoolAddEdit } from './components/pages/serviceGraderPools/components/addEdit/ServiceGraderPoolAddEdit';
import { ServiceGroupSettingsAddEdit } from './components/pages/serviceGroupSettings/ServiceGroupSettingsAddEdit';
import { EmbloomQuestionnaireServiceOrganizationSettingAddEdit } from './components/pages/serviceOrganizationSettings/EmbloomQuestionnaireServiceOrganizationSettingAddEdit';
import { ServiceOrganizationSettingsAddEdit } from './components/pages/serviceOrganizationSettings/ServiceOrganizationSettingsAddEdit';
import { ServiceProviderAddEdit } from './components/pages/serviceProviders/ServiceProviderAddEdit';
import { ServiceReaderAddEdit } from './components/pages/serviceReaders/ServiceReaderAddEdit';
import { PayableServiceActivityCompensationPayoutAddEdit } from './components/pages/services/payableServiceActivities/PayableServiceActivityCompensationPayoutAddEdit';
import { ServiceAddEdit } from './components/pages/services/ServiceAddEdit';
import { ServiceDetails } from './components/pages/services/ServiceDetails';
import { ServiceList } from './components/pages/services/ServiceList';
import { ServiceSupervisorAddEdit } from './components/pages/serviceSupervisors/ServiceSupervisorAddEdit';
import { ThirdPartyIncomingMessages } from './components/pages/thirdPartyIncomingMessages/ThirdPartyIncomingMessages';
import { ThirdPartyMessagesList } from './components/pages/thirdPartyMessages/ThirdPartyMessagesList';
import { UzoviAddEdit } from './components/pages/uzovis/UzoviAddEdit';
import { UzoviList } from './components/pages/uzovis/UzoviList';

export const namedRoutes = {
    patientCarePath: {
        element: <PatientEpisodeCategory />,
        path: '/patients/:patientId/:episodeCategory/:activeTab',
    },
} as const;

/* eslint-disable sort-keys -- For routes we prefer the order: path, element  */
export const routes = [
    ...Object.values(namedRoutes),
    { path: '/dashboard/:episodeCategory', element: <EpisodeCategoryOutclinicDashboard /> },
    { path: '/selectEmployment', element: <LoginSelectEmployment /> },
    { path: '/setMfa', element: <SetMfa /> },
    { path: '/', element: <AdminHomepage /> },
    { path: '/home', element: <HomePage /> },
    { path: '/employments/add', element: <EmploymentsAddEdit /> },
    { path: '/employments/selectOneServiceProvider', element: <EmploymentsSelectOneServiceProvider /> },
    { path: '/employments/:employmentId', element: <EmploymentsAddEdit /> },
    { path: '/employments/sso/selectEmployment', element: <SsoSelectEmployment /> },
    {
        path: '/employments/:employmentId/personalSettings',
        element: <PersonalSettings />,
        children: [
            { index: true, element: <PersonalSettingsOverview /> },
            { path: 'serviceEmailNotifications', element: <ServiceEmailNotificationSettings /> },
            {
                path: 'preferenceList/:episodeCategory',
                element: <PersonalSettingsPreferenceListConsumerContainerWrapper />,
            },
            {
                path: 'preferenceList/:episodeCategory/serviceProvider',
                element: <PersonalSettingsPreferenceListProviderContainer />,
            },
            {
                path: 'episodeCategory/mentalHealth',
                element: <GgzPersonalSettingsContainer />,
            },
            {
                path: 'compensationPayouts/:episodeCategory',
                element: <PersonalSettingsActivityCompensationPayoutsList />,
            },
            { path: 'carePaths', element: <PersonalSettingsCarePathsOverview /> },
            { path: 'carePaths/:episodeCategory', element: <PersonalSettingsCarePath /> },
            { path: 'inactiveCarePaths', element: <PersonalSettingsInactiveCarePaths /> },
            { path: 'inactiveCarePaths/:episodeCategory', element: <PersonalSettingsInactiveCarePaths /> },
        ],
    },
    {
        path: '/employments/:employmentId/personalSettings/addCarePath',
        element: <PersonalSettingsAddCarePath />,
    },
    {
        path: '/employments/:employmentId/personalSettings/addCarePath/:episodeCategory',
        element: <PersonalSettingsAddCarePath />,
    },
    {
        path: '/employments/:employmentId/personalSettings/addRights/:episodeCategory',
        element: <PersonalSettingsAddRights />,
    },
    { path: '/patients', element: <Patients /> },
    { path: '/patients/sso/notFound', element: <PatientNotFoundSso /> },
    { path: '/patients/add', element: <PatientsAddEdit /> },
    { path: '/patients/newPatient', element: <NewPatientSearchBar /> },
    { path: '/patients/add/sso/:ssoId', element: <PatientsAddEdit /> },
    { path: '/patients/sso/insufficientData', element: <PatientSsoInsufficientData /> },
    { path: '/patients/noBsn', element: <PatientSearchWithoutIdentifierSocialSecurity /> },
    { path: '/patients/:id/edit', element: <PatientsAddEdit /> },
    { path: '/patients/:id', element: <PatientDetails /> },
    { path: '/patients/:id/mergeSso/:ssoMergeId', element: <PatientDetails /> },
    { path: '/patients/:patientId/verify/:ssoId', element: <PatientSelectOrAdd /> },
    { path: '/patients/selectOrAdd/:patientId/:ssoId', element: <PatientSelectOrAdd /> },
    { path: '/patients/mergesso/:patientId/:ssoId', element: <PatientMergeSsoWrapper /> },
    { path: '/patients/:patientId/:episodeCategory', element: <PatientEpisodeCategory /> }, // this route is deprecated, use the named route that includes the active tab
    { path: '/episode', element: <Episode /> },
    { path: '/contactsAndTasks', element: <ContactsAndTasksPage /> },
    { path: '/medicalProtocol', element: <ContactsAndTasksPage /> },
    { path: '/processes', element: <AdminProcesses /> },
    { path: '/processes/open', element: <AdminProcesses /> },
    { path: '/processes/:id', element: <AdminProcessDetails /> },
    { path: '/processes/new/:id', element: <NewAdminProcessDetails /> },
    { path: '/devices', element: <DevicesAndAccessories tab={DevicesAndAccessoriesTab.devices} /> },
    {
        path: '/devices/accessories',
        element: <DevicesAndAccessories tab={DevicesAndAccessoriesTab.accessories} />,
    },
    { path: '/devices/accessories/add', element: <DeviceAccessoriesAddEdit /> },
    { path: '/devices/accessories/:id', element: <DeviceAccessoriesAddEdit /> },
    { path: '/devices/details/:id', element: <DeviceDetails /> },
    {
        path: '/mdoManagement',
        element: (
            <GroupMeetingManagement
                key="mdoManagement"
                type={GroupMeetingType.bariMdo}
            />
        ),
    },
    {
        path: '/groupSessionManagement',
        element: (
            <GroupMeetingManagement
                key="groupSessionManagement"
                type={GroupMeetingType.bariGroupSession}
            />
        ),
    },
    { path: '/serviceProviders/add', element: <ServiceProviderAddEdit /> },
    { path: '/serviceProviders/:id', element: <ServiceProviderAddEdit /> },
    {
        path: '/serviceOrganizationSettings/add',
        element: <ServiceOrganizationSettingsAddEdit />,
    },
    {
        path: '/serviceOrganizationSettings/:id',
        element: <ServiceOrganizationSettingsAddEdit />,
    },
    {
        path: '/questionnaireServiceOrganization/:id',
        element: <EmbloomQuestionnaireServiceOrganizationSettingAddEdit />,
    },
    { path: '/serviceConsumers/add', element: <ServiceConsumerAddEdit /> },
    { path: '/serviceConsumers/:id', element: <ServiceConsumerAddEdit /> },
    { path: '/serviceGraderPools/add', element: <ServiceGraderPoolAddEdit /> },
    { path: '/serviceGraderPools/:id', element: <ServiceGraderPoolAddEdit /> },
    { path: '/requests', element: <RequestsListContainer /> },
    { path: '/organizations', element: <OrganizationsList /> },
    { path: '/organizations/add', element: <OrganizationAdd /> },
    {
        path: '/organizations/:organizationId/view',
        element: <OrganizationView />,
        children: [
            { index: true, element: <OrganizationOverview /> },
            { path: 'details', element: <OrganizationDetails /> },
            { path: 'serviceEmailNotifications', element: <OrganizationServiceEmailNotificationSettings /> },
            { path: 'waitingTimes', element: <OrganizationWaitingTimes /> },
            {
                path: 'carePaths',
                element: <OrganizationCarePathsOverview />,
            },
            {
                path: 'carePaths/:episodeCategory',
                element: <OrganizationCarePath />,
            },
            {
                path: 'inactiveCarePaths',
                element: <OrganizationInactiveCarePaths />,
            },
            {
                path: 'inactiveCarePaths/:episodeCategory',
                element: <OrganizationInactiveCarePaths />,
            },
            {
                path: 'compensationPayouts/:episodeCategory',
                element: <ActivityCompensationPayoutsList />,
            },
            {
                path: 'funding/:episodeCategory',
                element: <OrganizationFunding />,
            },
            {
                path: 'preferenceList/:episodeCategory',
                element: <PersonalSettingsPreferenceListConsumerContainerOrganizationWrapper />,
            },
            { path: 'patientCount', element: <OrganizationPatientCount /> },
            { path: 'organizationPayouts', element: <OrganizationPayments /> },
        ],
    },
    { path: '/organizations/:organizationId/view/addEmployee', element: <AddKsyosEmployee /> },
    { path: '/organizations/:organizationId/view/addCarePath', element: <OrganizationAddCarePath /> },
    {
        path: '/organizations/:organizationId/view/addCarePath/success',
        element: <OrganizationAddCarePath />,
    },
    {
        path: '/organizations/:organizationId/view/addCarePath/:episodeCategory',
        element: <OrganizationAddCarePath />,
    },
    {
        path: '/organizations/:organizationId/view/addCarePath/:episodeCategory/success',
        element: <OrganizationAddCarePath />,
    },
    { path: '/organizations/:id', element: <OrganizationAdminDetails /> },
    { path: '/practitioners', element: <PractitionersList /> },
    { path: '/practitioners/:id', element: <PractitionerDetails /> },
    {
        path: '/practitioners/:id/profile',
        element: <PractitionerProfile />,
        children: [
            { index: true, element: <ProfileSettings /> },
            { path: 'security', element: <SecuritySettings /> },
            { path: 'sso', element: <SingleSignOnSettings /> },
        ],
    },
    {
        path: '/practitioners/:id/payments',
        element: <PractitionerPayments />,
    },
    {
        path: '/practitioners/:id/payments/:employmentId',
        element: <PractitionerPayments />,
    },
    { path: '/practitioners/:id/employments/add', element: <EmploymentAdd /> },
    { path: '/services', element: <ServiceList /> },
    { path: '/services/add', element: <ServiceAddEdit /> },
    { path: '/services/:id/edit', element: <ServiceAddEdit /> },
    { path: '/services/:id', element: <ServiceDetails /> },
    {
        path: '/services/:serviceId/serviceCompensationPayouts/add',
        element: <PayableServiceActivityCompensationPayoutAddEdit />,
    },
    {
        path: '/services/:serviceId/serviceCompensationPayouts/:id',
        element: <PayableServiceActivityCompensationPayoutAddEdit />,
    },
    { path: '/embloomQuestionnaires', element: <EmbloomQuestionnairesList /> },
    { path: '/managerAuthorizations', element: <ManagerRolesAuthorizations /> },
    { path: '/deviceTypes', element: <DeviceTypesList /> },
    { path: '/deviceTypes/add', element: <DeviceTypesAddEdit /> },
    { path: '/deviceTypes/:id', element: <DeviceTypesAddEdit /> },
    { path: '/deviceAccessoryTypes', element: <DeviceAccessoryTypesList /> },
    { path: '/deviceAccessoryTypes/add', element: <DeviceAccessoryTypesAddEdit /> },
    { path: '/deviceAccessoryTypes/:id', element: <DeviceAccessoryTypesAddEdit /> },
    { path: '/groups', element: <GroupsList /> },
    { path: '/groups/add', element: <GroupsAddEdit /> },
    { path: '/groups/:id/edit', element: <GroupsAddEdit /> },
    { path: '/groups/:id', element: <GroupsDetails /> },
    { path: '/groups/:groupId/view', element: <GroupView /> },
    { path: '/uzovis', element: <UzoviList /> },
    { path: '/uzovis/add', element: <UzoviAddEdit /> },
    { path: '/uzovis/:id/edit', element: <UzoviAddEdit /> },
    { path: '/insurers', element: <InsurersList /> },
    { path: '/insurers/add', element: <InsurerAddEdit /> },
    { path: '/insurers/:id/edit', element: <InsurerAddEdit /> },
    { path: '/insurers/:id', element: <InsurerDetails /> },
    { path: '/insurerTurnoverCeiling/add', element: <InsurerTurnoverCeilingAddEdit /> },
    { path: '/insurerTurnoverCeiling/:id/edit', element: <InsurerTurnoverCeilingAddEdit /> },
    { path: '/insurerTurnoverCeiling/:id', element: <InsurerTurnoverCeilingAddEdit /> },
    { path: '/insurerUzovis/add', element: <InsurerUzoviAddEdit /> },
    { path: '/insurerUzovis/:id', element: <InsurerUzoviAddEdit /> },
    { path: '/declarationActivities/add', element: <DeclarationActivityAddEdit /> },
    { path: '/declarationActivities/:id/edit', element: <DeclarationActivityAddEdit /> },
    { path: '/insurerServiceDeclarationRules/add', element: <InsurerServiceAddEdit /> },
    { path: '/insurerServiceDeclarationRules/:id/edit', element: <InsurerServiceAddEdit /> },
    { path: '/insurerServiceDeclarationRules/:id', element: <InsurerServiceRead /> },
    { path: '/nzaServiceDeclarationSettings/add', element: <NzaServiceDeclarationSettingAddEdit /> },
    { path: '/nzaServiceDeclarationSettings/:id/edit', element: <NzaServiceDeclarationSettingAddEdit /> },
    { path: '/nzaServiceDeclarationActivities/add', element: <NzaServiceDeclarationActivityAddEdit /> },
    {
        path: '/nzaServiceDeclarationActivities/:id/edit',
        element: <NzaServiceDeclarationActivityAddEdit />,
    },
    {
        path: '/insurerServiceDeclarationSettings/add',
        element: <InsurerServiceDeclarationSettingAddEdit />,
    },
    {
        path: '/insurerServiceDeclarationSettings/:id/edit',
        element: <InsurerServiceDeclarationSettingAddEdit />,
    },
    { path: '/jobs', element: <JobsList /> },
    { path: '/featureFlags', element: <FeatureFlags /> },
    { path: '/serviceGroupSettings/add', element: <ServiceGroupSettingsAddEdit /> },
    { path: '/serviceGroupSettings/:id', element: <ServiceGroupSettingsAddEdit /> },
    { path: '/fundingLogs', element: <FundingLogs /> },
    { path: '/fundingSettings/add', element: <FundingSettingsAddEdit /> },
    { path: '/fundingSettings/:id', element: <FundingSettingsAddEdit /> },
    { path: '/outpatientClinic', element: <OutpatientClinicTaskList /> },
    { path: '/serviceSupervisors/add', element: <ServiceSupervisorAddEdit /> },
    { path: '/serviceSupervisors/:id', element: <ServiceSupervisorAddEdit /> },
    { path: '/serviceReaders/add', element: <ServiceReaderAddEdit /> },
    { path: '/serviceReaders/:id', element: <ServiceReaderAddEdit /> },
    { path: '/exports/fundus', element: <FundusNoShowsExportRequests /> },
    { path: '/exports/patientSatisfaction', element: <PatientQuestionnaireExport /> },
    {
        path: '/insurerServiceDeclarationActivities/add',
        element: <InsurerServiceDeclarationActivityAddEdit />,
    },
    {
        path: '/insurerServiceDeclarationActivities/:id/edit',
        element: <InsurerServiceDeclarationActivityAddEdit />,
    },
    { path: '/compensationPayouts/add', element: <CompensationPayoutAddEdit /> },
    { path: '/compensationPayouts/:id', element: <CompensationPayoutAddEdit /> },
    {
        path: '/serviceActivityCompensationPayout/add',
        element: <ServiceActivityCompensationPayoutAddEdit />,
    },
    {
        path: '/serviceActivityCompensationPayout/:id',
        element: <ServiceActivityCompensationPayoutAddEdit />,
    },
    { path: '/import/importDhd', element: <ImportDhd /> },
    { path: '/import/importNoShows', element: <ImportNoShows /> },
    { path: '/import/importRelationNumbers', element: <ImportRelationNumbers /> },
    { path: '/import/importBankAccountDetails', element: <ImportBankAccountDetails /> },
    { path: '/import/importOtpDevices', element: <ImportOtpDevices /> },
    { path: '/import/fundusScreening', element: <FundusScreeningManualImportPage /> },
    { path: '/finance/export/declarations', element: <DeclarationsExport /> },
    { path: '/finance/export/invoiceRecords', element: <InvoiceRecordsExport /> },
    { path: '/finance/export/payments', element: <PaymentsExport /> },
    { path: '/finance/export/ubd', element: <EmploymentTaxesDetailsExport /> },
    { path: '/finance/financing', element: <Financing /> },
    { path: '/finance/payments', element: <Payments /> },
    { path: '/finance/reports/:financialReportType', element: <RequestFinancialExport /> },
    { path: '/holter/dashboard', element: <HolterDashboard /> },
    { path: '/dermaAppRegistrations', element: <DermaAppRegistrationsList /> },
    { path: '/dermaAppRegistrations/:id/logins', element: <DermaAppLoginsList /> },
    { path: '/incomingMessages', element: <ThirdPartyIncomingMessages /> },
    { path: '/patientAccess', element: <PatientAccessList /> },
    { path: '/thirdPartyMessages', element: <ThirdPartyMessagesList /> },
    { path: '/desktopProcesses', element: <DesktopProcessesList /> },
    { path: '/fundusNoShows', element: <FundusNoShowsList /> },
    { path: '/exact/catchRedirect', element: <CatchExactRedirect /> },
    { path: '/exports/dato', element: <ExportForDato /> },
    { path: '/app', element: <Patients /> },
    { path: '/dataChecks', element: <DataChecks /> },
    { path: '/materialenBestellen/:episodeCategory?/:supplyCategory?', element: <OrderSupplies /> },
    { path: '/materialenBestellen/success', element: <OrderSuppliesSuccess /> },
    { path: '/accountRequest/:accountRequestId', element: <AccountRequestReviewByKsyosPage /> },
    {
        path: '/accountRequest/:accountRequestId/review',
        element: <AccountRequestReviewByOrganizationPage />,
    },
    { path: '*', element: <NotFoundError /> },
];

export const nonProductionRoutes = [{ path: '/fillDummyEctosenseReports', element: <FillDummyEctosenseReports /> }];
